module.exports = "/images/Icon industry-EntertaimentCenter.svg?cefa5ecf8e494d6f28b42ff76bf2b422";